<template>
  <div class="quiz-progress">
    <div class="progress-bar-container">
      <div 
        class="progress-bar" 
        :style="{ width: `${progressPercent}%` }"
      ></div>
    </div>
    <div class="progress-text">
      <span>{{ current }} de {{ total }} questões</span>
      <span class="answered-count">{{ answered }} respondida(s)</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  current: {
    type: Number,
    required: true
  },
  total: {
    type: Number,
    required: true
  },
  answered: {
    type: Number,
    required: true
  }
});

const progressPercent = computed(() => {
  if (props.total === 0) return 0;
  return (props.current / props.total) * 100;
});
</script>

<style scoped>
.quiz-progress {
  margin-bottom: 30px;
}

.progress-bar-container {
  width: 100%;
  height: 10px;
  background: #e9ecef;
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 10px;
}

.progress-bar {
  height: 100%;
  background: #129f46;
  transition: width 0.3s ease;
}

.progress-text {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #666;
}

.answered-count {
  font-weight: bold;
  color: #129f46;
}
</style>

